/* FBK stekker-stappenplan als wizard op mobiel (< 750px). WS4, 26-09-2026.
   Werkt op elk element met [data-fbk-wiz]:
     [data-fbk-wiz-step]   een scherm (6 fotostappen + kleurkeuze)
     [data-fbk-wiz-prev] / [data-fbk-wiz-next] (+ [data-fbk-wiz-next-txt], data-label-next / data-label-pick)
     [data-fbk-wiz-count]  teller, tekst uit data-fbk-wiz-count-tpl met __N__ en __T__
     [data-fbk-wiz-dots]   <ol> voor de voortgangsbolletjes
     [data-fbk-wiz-scroller] (optioneel) eigen scrollcontainer (popup); anders scrolt de pagina naar de wizard
     [data-fbk-wiz-focus]  kop die na een stapwissel de focus krijgt
   Desktop/tablet: geen wizard, alles blijft zichtbaar. API: el.fbkWiz.go(n, true) / .reset() / .step() */
(function(){
  if (window.fbkStekkerWiz) return;
  var MQ = window.matchMedia('(max-width: 749px)');
  var slice = Array.prototype.slice;

  function isRtl(){ return (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl'; }

  /* 01-10-2026: onderkant van de sticky header (px vanaf de bovenkant van het venster).
     Niet via scrollIntoView: het thema zet scroll-padding-top (145px) op html en de keuzehulp
     zet daar nog een scroll-margin-top bovenop, samen 247px. Dan schoot de stap na Volgende
     naar onder en viel de knop onder de vouw.
     01-10-2026 (2): de sticky USP-balk (.fbk-uspbar-holder) telt nu mee. Hij plakt direct onder de header,
     anders viel "Stap 2 van 7" na Volgende half onder die balk. Per sticky element tellen we de plek waar
     het blijft plakken (CSS top + eigen hoogte), dus ook als de pagina nog bovenaan staat. */
  var STICKY_TOP = '.shopify-section-group-header-group, .fbk-uspbar-holder, [data-fbk-sticky-top]';
  function headerOffset(){
    var off = 0;
    var lim = window.innerHeight * 0.5;
    var els = document.querySelectorAll(STICKY_TOP);
    for (var i = 0; i < els.length; i++){
      var cs = window.getComputedStyle(els[i]);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      var b = els[i].getBoundingClientRect();
      if (b.height <= 0) continue;
      var bottom;
      if (cs.position === 'fixed'){
        bottom = b.bottom;
      } else {
        var t = parseFloat(cs.top);
        bottom = (isNaN(t) ? Math.max(0, b.top) : t) + b.height;
      }
      if (bottom > off && bottom < lim) off = bottom;
    }
    if (!off){
      var rs = window.getComputedStyle(document.documentElement);
      var v = (parseFloat(rs.getPropertyValue('--header-height')) || 0) +
              (parseFloat(rs.getPropertyValue('--sticky-uspbar-enabled')) || 0) * (parseFloat(rs.getPropertyValue('--uspbar-height')) || 0);
      if (v > 0 && v < lim) off = v;
    }
    return Math.round(off);
  }

  /* zet de bovenkant van el direct (zonder animatie) net onder de sticky header */
  function alignTop(el){
    if (!el) return;
    var want = headerOffset() + 8;
    var top = el.getBoundingClientRect().top;
    if (Math.abs(top - want) <= 2) return;
    /* 10-10-2026: staat de bovenkant van de kaart al in beeld (onder de header, bovenste kwart),
       dan niet schuiven. Anders sprong de pagina bij Volgende omlaag terwijl er niets te halen viel. */
    if (top > want && top < want + window.innerHeight * 0.25) return;
    var y = Math.max(0, (window.pageYOffset || document.documentElement.scrollTop || 0) + top - want);
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
  }

  function setup(root){
    if (!root || root.fbkWiz) return root ? root.fbkWiz : null;
    var steps = slice.call(root.querySelectorAll('[data-fbk-wiz-step]'));
    var total = steps.length;
    if (!total) return null;
    var prev = root.querySelector('[data-fbk-wiz-prev]');
    var next = root.querySelector('[data-fbk-wiz-next]');
    var nextTxt = root.querySelector('[data-fbk-wiz-next-txt]');
    var count = root.querySelector('[data-fbk-wiz-count]');
    var dots = root.querySelector('[data-fbk-wiz-dots]');
    var scroller = root.querySelector('[data-fbk-wiz-scroller]');
    var tpl = root.getAttribute('data-fbk-wiz-count-tpl') || '__N__ / __T__';
    var lblNext = next ? (next.getAttribute('data-label-next') || '') : '';
    var lblPick = next ? (next.getAttribute('data-label-pick') || lblNext) : '';
    var cur = 0;

    if (dots){
      dots.innerHTML = '';
      for (var i = 0; i < total; i++) dots.appendChild(document.createElement('li'));
    }

    function eager(i){
      var s = steps[i];
      if (!s) return;
      slice.call(s.querySelectorAll('img[loading="lazy"]')).forEach(function(im){ im.setAttribute('loading', 'eager'); });
    }

    function render(){
      var on = MQ.matches;
      root.classList.toggle('is-on', on);
      steps.forEach(function(s, i){
        s.hidden = on && i !== cur;
        s.classList.toggle('is-cur', on && i === cur);
      });
      root.classList.toggle('is-first', cur === 0);
      root.classList.toggle('is-last', cur === total - 1);
      if (prev) prev.hidden = cur === 0;
      if (next) next.hidden = cur === total - 1;
      if (nextTxt) nextTxt.textContent = (cur === total - 2) ? lblPick : lblNext;
      if (count) count.textContent = tpl.replace('__N__', String(cur + 1)).replace('__T__', String(total));
      if (dots){
        slice.call(dots.children).forEach(function(d, i){
          d.classList.toggle('is-cur', i === cur);
          d.classList.toggle('is-done', i < cur);
        });
      }
      if (on){ eager(cur); eager(cur + 1); }
    }

    function go(n, focus){
      cur = Math.max(0, Math.min(total - 1, n));
      render();
      root.dispatchEvent(new CustomEvent('fbk:wiz-step', { detail: { step: cur, total: total } }));
      if (!focus || !MQ.matches) return;
      /* popup: eigen scrollvak terug naar boven; pagina: kaart altijd op dezelfde plek net onder de header */
      if (scroller){ scroller.scrollTop = 0; }
      else { alignTop(root); }
      var h = steps[cur].querySelector('[data-fbk-wiz-focus]');
      if (h){
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
      }
    }

    if (next) next.addEventListener('click', function(){ go(cur + 1, true); });
    if (prev) prev.addEventListener('click', function(){ go(cur - 1, true); });

    /* pijltjestoetsen (alleen in wizard-modus, niet in invoervelden) */
    root.addEventListener('keydown', function(e){
      if (!MQ.matches) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) return;
      var fwd = (e.key === 'ArrowRight') !== isRtl();
      e.preventDefault();
      go(cur + (fwd ? 1 : -1), true);
    });

    /* vegen over de foto's (niet over knoppen) */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function(e){
      if (!MQ.matches || !e.touches || e.touches.length !== 1) { x0 = null; return; }
      var t = e.target;
      if (t && t.closest && t.closest('button, a, input, [data-fbk-wiz-noswipe]')) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function(e){
      if (x0 === null || !MQ.matches || !e.changedTouches) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 50 || Math.abs(dy) > 40) return;
      var fwd = (dx < 0) !== isRtl();
      if (fwd && cur < total - 1) go(cur + 1, true);
      else if (!fwd && cur > 0) go(cur - 1, true);
    }, { passive: true });

    if (MQ.addEventListener) MQ.addEventListener('change', render); else if (MQ.addListener) MQ.addListener(render);
    render();

    root.fbkWiz = {
      go: go,
      reset: function(){ cur = 0; render(); if (scroller) scroller.scrollTop = 0; },
      step: function(){ return cur; },
      total: total,
      isOn: function(){ return MQ.matches; }
    };
    return root.fbkWiz;
  }

  window.fbkStekkerWiz = {
    setup: setup,
    headerOffset: headerOffset,
    init: function(scope){ slice.call((scope || document).querySelectorAll('[data-fbk-wiz]')).forEach(setup); }
  };
  function boot(){ window.fbkStekkerWiz.init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ window.fbkStekkerWiz.init(e.target); });
})();
